import { render, staticRenderFns } from "./CommonFilterGroup.vue?vue&type=template&id=fbf84db4"
import script from "./CommonFilterGroup.vue?vue&type=script&lang=js"
export * from "./CommonFilterGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports